import React from 'react';
import rightArrowAlt from './img/bx-right-arrow-alt.svg';
import { ButtonBasic, InputDynamicWidth, Sceleton } from '@lk-gtcom/ecomlab-components';
import { useState, useEffect, useRef, Ref } from 'react';
import { BordCard } from '../BordCard/BordCard';
import { ModalCreateBoard } from '../ModalCreateBoard/ModalCreateBoard';
import customHeaders, { getSpace } from '../../../../common/headers';
import { useLocation } from 'react-router-dom';
import useGeneralStore from '../../../../store/general';
import { useDebounce } from '../../../../hooks/useDebounce';
import './BordTask.scss';

interface Board {
  id?: string | number;
  name: string;
  count_deals?: any;
  created_at?: string;
  start_time?: string; // для задач
  end_time?: string; // для задач
  count_events?: number | string; // для задач
  color: string | null;
}

interface BordTaskProps {
  ref?: Ref<HTMLDivElement>;
  dependenciesUpdate: [],
  setIsOpen: (isOpen: boolean) => void;
  isOpen: boolean;
  taskId?: string;
  setCurrentBordTask: (board: Board | null) => void;
  setBordListLength: (length: number) => void
  crm?: boolean
  ticket?: boolean
  task?: boolean
}

const BordTask = ({
  ref,
  setIsOpen,
  isOpen,
  taskId,
  dependenciesUpdate = [],
  setCurrentBordTask,
  setBordListLength,
  crm = false,
  ticket = false,
  task = false
}: BordTaskProps) => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const location = useLocation();
  const [isModal, setIsModal] = useState(false);
  const [boards, setBoards] = useState<Board[]>([]);
  const [loadingBoards, setLoadingBoards] = useState(true)
  const [currentBoard, setCurrentBoard] = useState<Board | null>(null);
  const [isEdit, setIsEdit] = useState(false);
  const boardRef = useRef<HTMLDivElement>(null);
  const [search, setSearch] = useState('')

  // Получение воронок
  const fetchGetBord = () => {

    let search_param = search ? `&search=${search}` : ''

    let url = ` https://portals.ecomru.ru/api/crm/funnels/${taskId}?page=1&limit=10000${search_param}`
    if (ticket) {
      url = ` https://portals.ecomru.ru/api/ticket/funnel/${taskId}?page=1&limit=10000${search_param}`
    }
    if (task) {
      url = ` https://portals.ecomru.ru/api/v3/tasks/board/task_boards?${search_param}`;
    }

    setLoadingBoards(true)

    const body = JSON.stringify({
      task_id: taskId
    });

    fetch(url, { method: task ? 'POST' : 'GET', headers, body: task ? body : undefined })
      .then((res) => res.json())
      .then((json) => {
        let bordsList;
        if (task) {
          bordsList = json || []
        } else {
          bordsList = json?.data || []
        }
        setBoards(bordsList);
        setBordListLength(bordsList?.length || 0)
      })
      .catch((err) => console.error(err))
      .finally(() => setTimeout(() => setLoadingBoards(false), 1000))
  };

  useEffect(() => {
    if (taskId) {
      fetchGetBord();
    }
  }, [taskId, ...dependenciesUpdate]);

  useEffect(() => {
    setCurrentBordTask(currentBoard);
  }, [currentBoard]);

  const toggleOpen = () => setIsOpen(!isOpen);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const bordIdFromQuery = searchParams.get('bord_id');

    if (boards?.length) {
      let current_board = boards.filter(({ id }) => id == bordIdFromQuery)
      if (current_board?.[0]) {
        setCurrentBoard(current_board?.[0])
      }
    }

  }, [boards])

  const debounceSearch = useDebounce(fetchGetBord, 1000)
  useEffect(() => {
    if (taskId) {
      debounceSearch(search)
    }
  }, [search]);

  return (
    <>
      {isModal && (
        <ModalCreateBoard
          fetchGetBord={fetchGetBord}
          currentBord={currentBoard}
          setIsModal={setIsModal}
          taskId={taskId}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          crm={crm}
          task={task}
          ticket={ticket}
        />
      )}

      <div
        className={isOpen ? 'bord-task_open' : 'bord-task'}
        ref={ref || boardRef}
      >
        <div className='bord-task__btn-group'>
          <button className='bord-task__btn'
            onClick={toggleOpen}
          >
            <img
              src={rightArrowAlt}
              style={{ transform: isOpen ? 'rotate(180deg)' : '' }}
              alt="Toggle panel"
            />
          </button>
          <ButtonBasic
            green
            width='160px'
            minWidth='160px'
            text='Добавить'
            size='26px'
            style={{
              minHeight: '26px',
              borderRadius: '4px'
            }}
            onClick={() => setIsModal(true)}
          />
        </div>

        <div className={isOpen ? 'bord-task__content_open' : 'bord-task__content'}>
          <InputDynamicWidth
            isOpen
            placeholder="Поиск"
            position="left"
            maxWidth="100%"
            value={search}
            onChange={setSearch}
          />

          {
            loadingBoards ?
              [...Array(9)].map((_el, ind) => {
                return <Sceleton
                  width={'192px'}
                  height={'53px'}
                />
              })
              :
              boards?.map((board) => (
                <BordCard
                  {...board}
                  key={board?.id}
                  id={board?.id}
                  name={board.name}
                  count_deals={task ? board?.count_events : board?.count_deals}
                  date={board.created_at}
                  created_at={task ? board.start_time : board.created_at}
                  fetchGetBord={fetchGetBord}
                  setIsModal={setIsModal}
                  setCurrentBord={setCurrentBoard}
                  currentBord={currentBoard}
                  setIsEdit={setIsEdit}
                  crm={crm}
                  ticket={ticket}
                  task={task}
                />
              ))
          }
        </div>

        <div className={isOpen ? 'bord-task__content-btns' : 'bord-task__content-btns_open'}>
          {/* <button className='bord-task__btn' onClick={toggleOpen}></button> */}
        </div>
      </div>
    </>
  );
};

export { BordTask };